import { SuggestedTopicAPIData } from '../../../../types/growth-api';
import { AgendaTopicDTO } from './agenda-topic';

export class SuggestedTopicDTO {
	id: string;
	agendaTopic: AgendaTopicDTO | null;
	bonusIds: string[];
	createdAt: Date;
	guestId: string;
	hostId: string;
	llmRunId: string;
	summary: string;
	updatedAt: Date;
	constructor(data: SuggestedTopicAPIData) {
		this.id = data.id;
		this.agendaTopic = data.agenda_topic ? new AgendaTopicDTO(data.agenda_topic) : null;
		this.bonusIds = data.bonus_ids;
		this.createdAt = new Date(data.created_at);
		this.guestId = data.guest_id;
		this.hostId = data.host_id;
		this.llmRunId = data.llm_run_id;
		this.summary = data.summary;
		this.updatedAt = new Date(data.updated_at);
	}
}
